export function groupPosts(posts) {
  const groupedPosts = [];
  const groupIndex = new Map();

  posts.forEach((post) => {
    if (post.type === "reply") {
      groupedPosts.push(post);
      return;
    }
    
    const isRepost = post.type === "repost";
    let userId = "";
    let postId = "";
    
    if (isRepost) {
      userId = post.repostedPost.authorUserId;
      postId = post.repostedPost.id;
    } else {
      userId = post.authorUserId;
      postId = post.id;
    }
    
    const date = new Date(post.publishedAt).toLocaleDateString();
    const key = `${date}-${userId}`;
    let group = groupIndex.get(key);
    if (!group) {
      group = { date, userId, posts: [], repostIds: new Set(), originalPostIds: new Set() };
      groupedPosts.push(group);
      groupIndex.set(key, group);
    }
    // If this is an original post, remove its reposts and add the original
    if (!isRepost) {
      if (!group.originalPostIds.has(postId)) {
        group.posts = group.posts.filter((post) => {
          if (post.type === "repost") {
            return post.repostedPost?.id !== postId;
          }
          return true;
        });
        group.repostIds.delete(postId);
        group.posts.push(post);
        group.originalPostIds.add(postId);
      }
    } else {
      // If this is a repost, add it only if the original post is not in the group
      if (!group.originalPostIds.has(postId) && !group.repostIds.has(postId)) {
        group.posts.push(post);
        group.repostIds.add(postId);
      }
    }
  });

  return groupedPosts.map((group) => {
    if (!group.posts || !Array.isArray(group.posts)) {
      return group;
    }
    return group.posts.length > 1
      ? { ...group, isCarousel: true }
      : group.posts[0];
  });
}
